import {FC} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {OAuthCallbackInstabasePage} from "./Pages/Public/OAuthCallbackInstabasePage";
import {OAuthCallbackGooglePage} from "./Pages/Public/OAuthCallbackGooglePage";

type AppRoutesPublicProps = {}

export const AppRoutesPublic: FC<AppRoutesPublicProps> = (props) => {
  return (
    <Switch>
      <Route exact={true} path="/public"><Redirect to="/me"/></Route>
      <Route path="/public/oauth/callback/google" component={OAuthCallbackGooglePage}/>
      <Route path="/public/oauth/callback/instabase" component={OAuthCallbackInstabasePage}/>
      <Route
        path="/public/coupons/:id"
        render={({match, location}) => <Redirect to={`/c/${match.params.id}${location.search}`}/>}
      />
      <Route
        path="/public/hubs/:id"
        render={({match, location}) => <Redirect to={`/h/${match.params.id}${location.search}`}/>}
      />
    </Switch>
  )
};
